import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Policy from "../pages/services/policy/page";
import Asset from "../pages/services/asset/page";
import Life from "../pages/services/life/page";
import Enterprise from "../pages/services/enterprise/page";
import Testimonials from "../pages/testimonials/page";
import Insights from "../pages/insights/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/policy",
    element: <Policy />,
  },
  {
    path: "/services/asset",
    element: <Asset />,
  },
  {
    path: "/services/life",
    element: <Life />,
  },
  {
    path: "/services/enterprise",
    element: <Enterprise />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/insights",
    element: <Insights />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
